import { useEffect, useRef } from "react";
import { useAuth } from "@/context/AuthContext";

export function AuthCallback() {
  const processed = useRef(false);
  const { completeGoogleSession } = useAuth();

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(window.location.hash.replace("#", "")).get("session_id");
    completeGoogleSession(sessionId).finally(() => window.history.replaceState(null, "", window.location.pathname));
  }, [completeGoogleSession]);

  return <main className="ns-auth-page" data-testid="auth-callback-page"><div className="ns-auth-card"><p className="ns-kicker">Opening your portal</p><h1>Signing you in…</h1></div></main>;
}
